import { render, staticRenderFns } from "./PersonComments.vue?vue&type=template&id=a726d5f2&"
import script from "./PersonComments.vue?vue&type=script&lang=js&"
export * from "./PersonComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports